// tsc Insurance.tsx --jsx react --skipLibCheck
import * as React from 'react'
import { Accordion, Card, Button, Form, Image, Container, Spinner } from 'react-bootstrap'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import * as _ from 'lodash'

import './Settings.css'
import AccountSettings from './AccountSettings'
import { asyncUserData } from '../../redux/actions'
import CompanyTab from './CompanyTab'
import EditDocument from './EditDocument'
import Insurance from './Insurance/Insurance'
import InsurancePolicy, { PolicyType } from '../../types/InsurancePolicy'

import PackingMaterialsList from './PackingMaterialsList'
import Password from './Password'
import RatesTab from './RatesTab'

import DocumentsSettings from './DocumentsSettings'
import Vehicles from './Vehicles/Vehicles'
import Vehicle, { Make, Model, OdometerReading } from '../../types/Vehicle'
import { copyObject } from '../../utils'
import { companyObj, CompanyT } from '../../types/Company'
import { UserT, initUserObj } from '../../types/Users'
import Manual from './Manual/Manual'
import PaymentTab from './PaymentTab'
import MailServerTab from './MailServerTab/MailServerTab'
import CompanyWorkersTab from './CompanyWorkersTab/CompanyWorkersTab'
import { currentUserCompanyId, currentUserIsManager } from '../../utils/currentUser'
import { IAppState } from '../../redux/reducers'
import { PackingMaterialsTab } from './PackingMaterialsTab'
import { getCurrentUser, updateCurrentUser } from './SettingsApi'
import { AxiosInstance } from '../../utils/RequestMethods'
import config from '../../constants/config'


interface SettingsProps {

}

const INSURANCE_LIST: Array<InsurancePolicy> = [
    {
        id: 7,
        coinsurance: 80,
        deductible: 1000.00,
        effectiveDate: new Date(),
        endorsements: [],
        expirationDate: new Date(),
        fkAdditionalInsured: [1, 2, 3],
        fkInsurer: 5,
        fkPrimaryNamedInsured: 5,
        limitAggregate: 50000.00,
        limitOccurrence: 25000.00,
        policyNumber: 'DF98DSFNAKEW',
        policyType: PolicyType['General Liability'],
        premium: 300.00,
        premiumDiscount: 25.00
    },
    {
        id: 8,
        coinsurance: 80,
        deductible: 8900.00,
        effectiveDate: new Date(),
        endorsements: [],
        expirationDate: new Date(),
        fkAdditionalInsured: [1, 2, 3],
        fkInsurer: 5,
        fkPrimaryNamedInsured: 5,
        limitAggregate: 50000.00,
        limitOccurrence: 25000.00,
        policyNumber: 'C4LKJSDFALKDJAF',
        policyType: PolicyType["Workers' Comp"],
        premium: 375.00,
        premiumDiscount: 30.00
    }
]

const DOCUMENTS = [
    {
        id: 3,
        title: 'Client Agreement',
        content: 'This is a client agreement.'
    },
    {
        id: 6,
        title: 'Inventory Sheet',
        content: 'This is an Inventory Sheet'
    },
    {
        id: 9,
        title: 'Cube Sheet',
        content: 'This is a cube sheet.'
    }
]

const settingsStyle = {
    display: 'grid',
    gridTemplateColumns: '200px 1fr'
}


const tabs = [{
    name: "account",
    label: "Account",
    isManager: false,
    isSales: false,
},
{
    name: "password",
    label: "Password",
    isManager: false,
    isSales: false,
},
{
    name: "salesSchedule",
    label: "Sales Schedule",
    isManager: false,
    isSales: true,
},
{
    name: "company",
    label: "General",
    isManager: true,
    isSales: false,
},
{
    name: "documents",
    label: "Documents",
    isManager: true,
    isSales: false,
},
{
    name: "payment",
    label: "Payment Processing",
    isManager: false,
    isSales: false,
},
{
    name: "manual",
    label: "Manual",
    isManager: true,
    isSales: false,
},
{
    name: "mailServer",
    label: "Mail Server",
    isManager: true,
    isSales: false,
},
{
    name: "insurance",
    label: "Insurance",
    isManager: true,
    isSales: false,
},
{
    name: "vehicles",
    label: "Vehicles",
    isManager: true,
    isSales: false,
},
{
    name: "rates",
    label: "Rates",
    isManager: true,
    isSales: false,
},
{
    name: "materials",
    label: "Materials",
    isManager: true,
    isSales: false,
},
{
    name: "workers",
    label: "Workers",
    isManager: true,
    isSales: false,
},

]

const Settings: React.FunctionComponent<SettingsProps> = ({ }): JSX.Element => {
    const [activeSetting, setActiveSetting] = React.useState('account')
    const [user, setUser] = React.useState(initUserObj);
    const [company, setCompany] = React.useState(copyObject(companyObj))
    const [isReady, setIsReady] = React.useState(false)
    let auth = useSelector((state: IAppState) => state.auth)
    const [compnayIsReady, setCompnayIsReady] = React.useState(false)
    const [selectedCompanyId, setSelectedCompanyId] = React.useState<number | null>(null)
    const [settingDefault, setSettingDefault] = React.useState(false)
    const userRole = auth && auth.userData && _.isArray(auth.userData.roles) && auth.userData.roles[0]
    const isManager = currentUserIsManager()
    const companyId = currentUserCompanyId()

    const loadCompany = (id: number): void => {
        setCompnayIsReady(false)
        const options = { data: { context: 'edit' } }
        AxiosInstance.get(`${config.url.companies}/${id}`, options).then((res) => {
            if (res && res.data) {
                setCompany(res.data)
                setCompnayIsReady(true)
            }
        }).catch((error) => {
            console.log('loadCompany error', error)
        })
    }

    React.useEffect(() => {
        try {
            getCurrentUser().then((res) => {
                setUser(res)
                // تحديد الشركة الافتراضية عند تحميل المستخدم
                if (res?.defaultCompany) {
                    setSelectedCompanyId(res.defaultCompany)
                } else if (res?.companies?.length > 0) {
                    const def = res.companies.find(c => c.isDefault)
                    setSelectedCompanyId(def?.id ?? res.companies[0].id)
                }
            })
        } catch (error) { }
    }, []);

    React.useEffect((): void => {
        console.log('in Settings->useEffect')
        console.log("companyId", companyId)
        if (companyId == null || companyId == undefined) {
            setIsReady(true)
        } else {
            const options = { data: { context: 'edit' } }
            AxiosInstance.get(`${config.url.companies}/${companyId}`, options).then((res) => {
                if (res && res.data) {
                    console.log('COMPANYYYY', res.data)
                    setCompany(res.data)
                    setCompnayIsReady(true)
                }
                setIsReady(true)
            }).catch((error) => {
                console.log('FALSE: ', error)
                setIsReady(true)
            })
        }
    }, [])

    const handleCompanyChange = (id: number): void => {
        setSelectedCompanyId(id)
        loadCompany(id)
    }

    const handleSetDefault = async (): Promise<void> => {
        if (!selectedCompanyId) return
        setSettingDefault(true)
        try {
            // POST /wp/v2/companies/{id}/set_default
            await AxiosInstance.post(`${config.url.companies}/${selectedCompanyId}/set_default`, {})
            // تحديث defaultCompany + isDefault داخل مصفوفة companies في نفس الوقت
            setUser(prev => ({
                ...prev,
                defaultCompany: selectedCompanyId,
                companies: prev.companies?.map(c => ({
                    ...c,
                    isDefault: c.id === selectedCompanyId,
                })),
            }))
            await asyncUserData()
        } catch (error) {
            console.log('handleSetDefault error', error)
        } finally {
            setSettingDefault(false)
        }
    }

    const packingMaterialsForm = (): Array<JSX.Element> => {
        let arr = []
        for (let i = 0; i < PackingMaterialsList.length; ++i) {
            arr.push(
                <div style={{ display: 'grid', gridTemplateColumns: 'minmax(100px, 1fr) 3fr' }}>
                    <span>
                        <Form.Label>{PackingMaterialsList[i].label}</Form.Label>
                    </span>
                    <span>
                        <Form.Control
                            className='input-material' />
                    </span>
                </div>
            )
        }
        return arr
    }



    const updateCompany = (newCompany: CompanyT): void => {
        setCompany(copyObject(newCompany))
    }


    const saveCurrentUser = async (params = {}): Promise<UserT> => {
        try {
            let res = await updateCurrentUser(params)
            if (res) {
                setUser(res)
                // call refreshAccount in  store
                let resUpdate = await asyncUserData()
                return res;
            }
        } catch (error) {
            throw new Error(error)
        }
    }
    const renderInsurance = () => {
        let ins = []
        INSURANCE_LIST.map(insurance => {
            ins.push(
                <>
                    <Card.Header>
                        <Accordion.Header as={Button} variant="link" eventKey={insurance.id.toString()}>
                            <div>
                                <h5>{PolicyType[insurance.policyType]} - {insurance.policyNumber}</h5>
                            </div>
                        </Accordion.Header>
                    </Card.Header>
                    <Accordion.Collapse eventKey={insurance.id.toString()}>
                        <Form>
                            <Form.Group>
                                <Form.Label>Policy Number</Form.Label>
                                <Form.Control value={insurance.policyNumber} />
                                <span style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }}>
                                    <span>
                                        <Form.Label>Effective Date</Form.Label>
                                        <Form.Control value={insurance.effectiveDate.toString()} />
                                    </span>
                                    <span>
                                        <Form.Label>Expiration Date</Form.Label>
                                        <Form.Control value={insurance.expirationDate.toString()} />
                                    </span>
                                </span>
                                <Form.Label>Policy</Form.Label>
                                <Form.Control type='file' />
                                <Button variant='info'>Save Insurance</Button>
                                <Button variant='danger'>Delete Insurance</Button>
                            </Form.Group>
                        </Form>
                    </Accordion.Collapse>
                </>)
        })
        return <Accordion>{ins}</Accordion>
    }

    const renderDocuments = () => {
        let d = []
        DOCUMENTS.map(doc => {
            d.push(
                <>
                    <Card.Header>
                        <Accordion.Header as={Button} variant="link" eventKey={doc.id.toString()}>
                            <div>
                                <h5>{doc.title}</h5>
                            </div>
                        </Accordion.Header>
                    </Card.Header>
                    <Accordion.Collapse eventKey={doc.id.toString()}>
                        <EditDocument content={doc.content} />
                    </Accordion.Collapse>
                </>)
        })
        return <Accordion>{d}</Accordion>
    }

    if (!isReady) {
        return (
            <Container className="mt-5 text-center">
                <Spinner animation="border" variant="info" />
            </Container>
        )
    }
    return (
        <Box height="100%" paddingBottom={2}>
            <div style={{ display: 'grid', gridTemplateColumns: '210px 1fr', height: '100%' }}>

                {/* ── Sidebar ── */}
                <div className="settings-sidebar">

                    <h2>User</h2>
                    {tabs.filter(x => !x.isManager && !x.isSales).map((item, index) => (
                        <div key={index} className="settings-nav-item">
                            <a
                                href='#'
                                className={activeSetting === item.name ? 'active-nav' : ''}
                                onClick={(e) => { e.preventDefault(); setActiveSetting(item.name) }}
                            >
                                {item.label}
                            </a>
                        </div>
                    ))}

                    {user.isSales && tabs.filter(x => x.isSales).map((item, index) => (
                        <div key={index} className="settings-nav-item">
                            <a
                                href='#'
                                className={activeSetting === item.name ? 'active-nav' : ''}
                                onClick={(e) => { e.preventDefault(); setActiveSetting(item.name) }}
                            >
                                {item.label}
                            </a>
                        </div>
                    ))}

                    {isManager && <>
                        <h2>Company</h2>

                        {/* Company Switcher */}
                        {user.companies && user.companies.length > 1 && (
                            <div className="company-switcher">
                                <span className="switcher-label">Active Company</span>

                                {user.defaultCompany && (
                                    <div className="default-badge">
                                        <span>★</span>
                                        <span>{user.companies.find(c => c.id === user.defaultCompany)?.name ?? ''}</span>
                                    </div>
                                )}

                                <Form.Select
                                    size="sm"
                                    value={selectedCompanyId ?? ''}
                                    onChange={(e) => handleCompanyChange(Number(e.target.value))}
                                >
                                    {user.companies.map(c => (
                                        <option key={c.id} value={c.id}>
                                            {c.name}{c.isDefault ? ' ★' : ''}
                                        </option>
                                    ))}
                                </Form.Select>

                                <button
                                    className="btn-set-default"
                                    disabled={settingDefault || selectedCompanyId === user.defaultCompany}
                                    onClick={handleSetDefault}
                                >
                                    {settingDefault
                                        ? <Spinner animation="border" size="sm" />
                                        : 'Set as Default'}
                                </button>
                            </div>
                        )}

                        {tabs.filter(x => x.isManager).map((item, index) => (
                            <div key={index} className="settings-nav-item">
                                <a
                                    href='#'
                                    className={activeSetting === item.name ? 'active-nav' : ''}
                                    onClick={(e) => { e.preventDefault(); setActiveSetting(item.name) }}
                                >
                                    {item.label}
                                </a>
                            </div>
                        ))}
                    </>}
                </div>

                {/* ── Content ── */}
                <div className="settings-content">
                    {activeSetting == 'account' && <AccountSettings user={user} saveCurrentUser={saveCurrentUser} />}
                    {activeSetting == 'password' && <Password />}
                    {(activeSetting == 'company' && compnayIsReady) && <CompanyTab company={company} updateCompany={updateCompany} />}
                    {(activeSetting == 'documents' && compnayIsReady) && <DocumentsSettings company={company} />}
                    {(activeSetting == 'payment' && compnayIsReady) && <PaymentTab company={company} />}
                    {(activeSetting == 'manual' && compnayIsReady) && <Manual company={company} />}
                    {(activeSetting == 'mailServer' && compnayIsReady) && <MailServerTab company={company} updateCompany={updateCompany} />}
                    {(activeSetting == 'rates' && compnayIsReady) && <RatesTab company={company} updateCompany={updateCompany} />}
                    {(activeSetting == 'vehicles' && compnayIsReady) && <Vehicles company={company} />}
                    {activeSetting == 'estimates' &&
                        <div>
                            <h2>Estimates</h2>
                            <p>Configure your company's default set of estimate line items by moving job type.</p>
                            <Accordion>
                                <Card.Header>
                                    <Accordion.Header as={Button} variant="link" eventKey={'local'}>
                                        <div><h5>Local Moving</h5></div>
                                    </Accordion.Header>
                                </Card.Header>
                                <Accordion.Collapse eventKey={'local'}><p>Hi</p></Accordion.Collapse>
                                <Card.Header>
                                    <Accordion.Header as={Button} variant="link" eventKey={'long'}>
                                        <div><h5>Long-distance Moving</h5></div>
                                    </Accordion.Header>
                                </Card.Header>
                                <Accordion.Collapse eventKey={'long'}><p>Hi</p></Accordion.Collapse>
                                <Card.Header>
                                    <Accordion.Header as={Button} variant="link" eventKey={'labor'}>
                                        <div><h5>Moving Labor</h5></div>
                                    </Accordion.Header>
                                </Card.Header>
                                <Accordion.Collapse eventKey={'labor'}><p>Hi</p></Accordion.Collapse>
                            </Accordion>
                        </div>}
                    {activeSetting == 'materials' &&
                        <div>
                            <PackingMaterialsTab company={company} updateCompany={updateCompany} />
                        </div>}
                    {activeSetting == 'insurance' && <Insurance />}
                    {activeSetting == 'workers' && <CompanyWorkersTab company={company} updateCompany={updateCompany} />}
                </div>

            </div>
        </Box>
    )
}

export default Settings
